import React from 'react';
import imgDjango from 'shared/assets/images/logos/django.svg';
import imgReact from 'shared/assets/images/logos/react.svg';
import imgPatternfly from 'shared/assets/images/logos/patternfly.svg';
import imgPython from 'shared/assets/images/logos/python.svg';
import { FaDocker } from 'react-icons/fa';
import { DiGit } from 'react-icons/di';
import { AuthContext } from 'shared/context/AuthContext';
class Footer extends React.Component {
	static contextType = AuthContext
	getYear = () => {
		return new Date().getFullYear();
	}
	
	render() {
		return (
			<>
			<footer className="pf-u-text-align-center education-platform">
				{this.context.state.isAuthUser &&
					<>
					<a target="blank" href="https://www.djangoproject.com/"><img className="logo" src={imgDjango} title="Django" alt="Django"></img></a>
					<a target="blank" href="https://www.python.org/"><img className="logo" src={imgPython} title="Python" alt="Python"></img></a>
					<a target="blank" href="https://www.patternfly.org"><img className="logo" src={imgPatternfly} title="PatternFly" alt="PatternFly"></img></a>
					</>
				}
				{/*
				<a target="blank" href="https://www.python.org/"><img className="logo" src={imgPython} title="Python" alt="Python"></img></a>
				<a target="blank" href="https://www.w3schools.com/jsref/default.asp"><img className="logo" src={imgJs} title="JS" alt="JS"></img></a>
				*/}
				<a target="blank" href="https://pl.reactjs.org/"><img className="logo" src={imgReact} title="React" alt="React"></img></a>
				{/* <a target="blank" href="https://pl.reactjs.org/" className="brand" title="React" alt="React"><FaReact size="32" /></a> */}
				{this.context.state.isAuthUser &&
					<>
					<a target="blank" href="https://git-scm.com" className="brand" title="Git" alt="Git"><DiGit size="40" /></a>
					<a target="blank" href="https://docs.docker.com" className="brand" title="Docker" alt="Docker"><FaDocker size="40" /></a>
					</>
				}
				<div className="pf-u-display-block" id="foot">© 2014 - {this.getYear()} ti.zspw.pl</div>
			</footer>
			</>
		);
	}
}
export default Footer;
